export default __webpack_public_path__ + "static/media/error.cf5e4a92.svg";